/** True for `http:` and `https:` URLs only. */
export const isValidUrl = (url: unknown): boolean => typeof url === 'string' && httpUrlOrUndefined(url) !== undefined;

/** Returns the URL if it is `http:` or `https:`, so stored URLs can't run `javascript:` in our origin when opened. */
export const httpUrlOrUndefined = (url: string | null | undefined): string | undefined => {
    try {
        return ['http:', 'https:'].includes(new URL(url ?? '').protocol) ? (url ?? undefined) : undefined;
    } catch {
        return undefined;
    }
};
